import SelectAll from './SelectAll';

export default SelectAll;
